interface AppLoaderProps {
  /** Text announced to screen readers while the loader is visible. */
  label?: string;
}

const AppLoader = ({ label = 'Loading' }: AppLoaderProps) => (
  <div
    className="min-h-screen w-full bg-lighter flex items-center justify-center"
    role="status"
    aria-live="polite"
    aria-label={label}
  >
    <div className="animate-spin rounded-full h-8 w-8 border-2 border-primary border-t-transparent" />
    <span className="sr-only">{label}</span>
  </div>
);

export default AppLoader;
